import { initializeTelegram } from '@/shared/telegram/bootstrap';

/**
 * Initializes the application and configures its dependencies.
 */
export async function init(options: { eruda: boolean }): Promise<void> {
  await initializeTelegram();

  try {
    const { initFaro } = await import('@/shared/observability');
    initFaro();
  } catch {}

  if (import.meta.env.DEV && options.eruda) {
    void import('eruda')
      .then(({ default: eruda }) => {
        eruda.init();
        eruda.position({ x: window.innerWidth - 50, y: 0 });
      })
      .catch(() => {
        console.info('Development console is unavailable.');
      });
  }

  // MSW (backend interceptor)
  const { env } = await import('@/shared/api');
  if (env.useMock && (import.meta.env.DEV || import.meta.env.MODE === 'e2e')) {
    const { worker } = await import('./mocks/browser');
    await worker.start({
      onUnhandledRequest: 'bypass',
    });
  }
}
